export default __webpack_public_path__ + "static/454-8de534d6a209146206ae96d0cc0f6331.gif";